export default __webpack_public_path__ + "static/media/playscreenshot.535cd32d.png";